import { Component, Input, OnInit } from '@angular/core';

import {PageHelper, PageNode, Site} from '../../common/services';

@Component({
  selector: 'p8-bdc-categories-list',
  templateUrl: './categories-list.component.html',
  styleUrls: ['./categories-list.component.scss']
})
export class CategoriesListComponent implements OnInit {
  @Input() site: Site;

  constructor(private pageHelper: PageHelper) { }

  ngOnInit() {}

  getMainCategories(): PageNode[] {
    return this.site.pages.children
      .filter((_page) => _page.data.is_published);
  }

  getSubCategories(children): PageNode[] {
    if (!children) {
      return [];
    }
    const pages = [...children];
    this.pageHelper.sortPages(pages);
    return pages.filter((_page) => _page.data.is_published);
  }

  collapseNodes(pages: PageNode[]): PageNode[] {
    if (!pages) {
      return [];
    }
    const listPages = pages.filter((_page: PageNode) => _page.data.is_published);
    const collapsedPages: PageNode[] = [];

    for (const page of listPages) {
      collapsedPages.push(page);
      collapsedPages.concat(this.collapseNodes(page.children));
    }
    return collapsedPages;
  }
}
